import {
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faImage,
  faFileAlt,
  faFileArchive,
  faPlayCircle,
  faStickyNote,
  faFileCode,
  faFileSignature,
} from "@fortawesome/free-solid-svg-icons";
import { getFileExtensionFromContentType } from "constants/acceptFiles";

/**
 * Returns an icon and CSS class based on the file extension of the given file name.
 * This function maps file extensions to specific icons and CSS classes. It determines the appropriate icon and
 * class for various file types, including PDFs, text files, images, audio files, and document files. The function
 * uses FontAwesome icons and returns an object containing the icon and the corresponding CSS class.
 * @param {string} fileName - The name of the file, including its extension.
 * @returns {Object} An object containing:
 *   - `icon`: The FontAwesome icon for the file type (e.g., `faFilePdf`, `faFileAlt`, etc.).
 *   - `className`: A CSS class associated with the file type (e.g., "text-danger", "text-gray", etc.).
 */
const renderIconFile = (fileName) => {
  const nameFile = getFileExtensionFromContentType(fileName);
  switch (nameFile) {
    case "pdf":
      return {
        icon: faFilePdf,
        className: "text-danger",
      };
    case "txt":
      return {
        icon: faFileAlt,
        className: "text-gray",
      };
    case "zip":
      return {
        icon: faFileArchive,
        className: "text-warning",
      };
    case "xml":
      return {
        icon: faFileCode,
        className: "text-info",
      };
    case "doc":
    case "docx":
    case "docm":
    case "dotx":
    case "dotm":
      return {
        icon: faFileWord,
        className: "text-blueWord",
      };
    case "xls":
    case "xlsx":
    case "xlsm":
    case "xltx":
    case "xltm":
    case "xlsb":
    case "xlam":
      return {
        icon: faFileExcel,
        className: "text-greenExcel",
      };
    case "ppt":
    case "pptx":
    case "pptm":
    case "potx":
    case "potm":
    case "ppam":
    case "ppsx":
    case "ppsm":
    case "sldx":
    case "sldm":
    case "thmx":
      return {
        icon: faFilePowerpoint,
        className: "text-orangePpt",
      };
    case "tif":
    case "tiff":
    case "gif":
    case "jpeg":
    case "jpg":
    case "jif":
    case "jfif":
    case "fpx":
    case "pcd":
    case "png":
      return {
        icon: faImage,
        className: "text-info",
      };
    case "avi":
    case "asf":
    case "asx":
    case "rmi":
    case "wma":
    case "wax":
    case "wav":
    case "mp3":
    case "mkv":
    case "mpeg-2":
    case "wmv":
    case "mp4":
    case "mov":
      return {
        icon: faPlayCircle,
        className: "text-danger",
      };
    case "pfx":
      return {
        icon: faFileSignature,
        className: "text-info",
      };
    default:
      return {
        icon: faStickyNote,
        className: "text-gray",
      };
  }
};

export default renderIconFile;
